module.exports = __webpack_public_path__ + "assets/badge-check.e257b3484ab6d92c4e3ee250761e1937.svg";